module.exports = __webpack_public_path__ + "media/mypage/images/icons/arrow_right_y-133864ca490049feda8877367399b664.svg";